module.exports = __webpack_public_path__ + "media/images/image_thedogs-37d0de50ea1b641873057978f0b3901b.jpg";